import { query } from '@kk/utils';

/**
 * 安全转化模块的预览id为发布id
 * @param {string} moduleId 需要转换的id
 * @param {string} [activityId] 可选参数，不穿使用url上面的id
 * @returns
 */
export function formatModuleId(moduleId, activityId) {
    const moduleIdData = moduleId.split('_');
    const currentActivityId = activityId ? activityId : query.get('id').split('_')[0];
    if (moduleIdData.length !== 3) {
        return moduleId;
    }
    return `${currentActivityId}_${moduleIdData[1]}_${moduleIdData[2]}`;
}
